export default __webpack_public_path__ + "static/media/DSCN2321.336f789a.JPG";